import { z } from 'zod';
import type { CMSComponent } from '@/components/cms/schemas';
import { CMSComponentSchema } from '@/components/cms/schemas';
import { CMSSEOSchema } from '../common';

const FeatureImageSchema = z
  .object({
    id: z.string(),
    alt: z.string().nullable(),
    url: z.string().url(),
  })
  .nullable();

const CategoriesSchema = z.object({
  title: z.string(),
  slug: z.string(),
  id: z.string(),
});

const DataSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    slug: z.string(),
    feature_image: FeatureImageSchema,
    date: z.string().datetime(),
    excerpt: z.string(),
    categories: z.array(CategoriesSchema),
    content: z.array(CMSComponentSchema),
  })
  .merge(CMSSEOSchema);

export interface BlogDetailedPageDataResponse {
  id: string;
  title: string;
  slug: string;
  date: string;
  excerpt: string;
  feature_image: z.infer<typeof FeatureImageSchema>;
  categories: z.infer<typeof CategoriesSchema>[];
  content: CMSComponent[];
  seo_page_title: string;
  seo_description: string;
  seo_keywords: string;
}

export const CMSBlogDetailedPageSchema = z.object({
  data: z.array(DataSchema),
});

export interface CMSBlogDetailedPageResponse {
  data: BlogDetailedPageDataResponse[];
}
